import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { ButtonLegacyModule } from '../button-legacy/button-legacy.module';
import { IconModule } from '../icon/icon.module';

@NgModule({
  declarations: [TooltipComponent],
  imports: [CommonModule, ButtonLegacyModule, IconModule],
  exports: [TooltipComponent],
})
export class TooltipModule {}
